<template>
    <div class="container">
        <b-modal v-model="warningModalShow" hide-header ok-only>
            <b-alert variant="warning" show>{{warningModalText}}</b-alert>
        </b-modal>
        <b-modal v-model="confirmModalShow" hide-header @ok="confirmDelete">
            <b-alert variant="warning" show>{{confirmModalText}}</b-alert>
        </b-modal>
        <b-modal ref="imagesModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
            <font-awesome-icon v-if="images.uploading || images.deleting" class="spinner" size="2x" icon="circle-notch" :spin="true"/>
            <div  v-else>
                <b-alert :variant="images.statusOk ? 'success':'warning'" :show="!!images.okMessage || !!images.errMessage">{{images.okMessage || images.errMessage}}</b-alert>
                <b-btn size="sm" class="float-right" variant="primary" @click.stop="$refs.imagesModal.hide();">
                    {{langPostEdit.close[locale]}}
                </b-btn>
            </div>
        </b-modal>
        <b-modal ref="videosModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
            <font-awesome-icon v-if="videos.uploading || videos.deleting" class="spinner" size="2x" icon="circle-notch" :spin="true"/>
            <div  v-else>
                <b-alert :variant="videos.statusOk ? 'success':'warning'" :show="!!videos.okMessage || !!videos.errMessage">{{videos.okMessage || videos.errMessage}}</b-alert>
                <b-btn size="sm" class="float-right" variant="primary" @click.stop="$refs.videosModal.hide();">
                    {{langPostEdit.close[locale]}}
                </b-btn>
            </div>
        </b-modal>
        <div v-if="post.fetching">
            <br /><br />
            <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
        </div>
        <div v-else-if="post.data">
            <div v-if="post.data.status === 'selling'">
                <br />
                <div class="row">
                    <hr class="col" />
                    <h3 class="col">{{langPostEdit.updateFiles[locale]}}</h3>
                    <hr class="col" />
                </div>
            
                <form-files-uploader :labelText="langPostEdit.uploadImages[locale]" :inputType="'image'" :files="files.images" :required="true" :fileChanged="imageAdded" :deleteFile="deleteImage" :tooltipTitle="langPostEdit.uploadImagesToolTip[locale]"/>
                <!--
                <form-files-uploader :labelText="langPostEdit.uploadVideos[locale]" :inputType="'video'" :files="files.videos" :required="false" :fileChanged="videoAdded" :deleteFile="deleteVideo" :tooltipTitle="langPostEdit.uploadVideosToolTip[locale]"/>
                -->
                <form class="form-create-post" v-on:submit.prevent="updatePost">
                    <!--
                    <br />
                    <div class="row">
                        <hr class="col" />
                        <h3 class="col">{{langPostEdit.status[locale]}} {{langPostEdit.selectAStatus[locale]}}</h3>
                        <hr class="col" />
                    </div>
                    <form-select :labelText="langPostEdit.selectAStatus[locale]" v-model="mutablePost.status" :options="[{text: langPostEdit.selling[locale], value: 'selling'}, {text: langPostEdit.sold[locale], value: 'sold'}]" :allowedValues="['sold', 'selling']" required :tooltipTitle="langPostEdit.selectAStatusToolTip[locale]"/>
                    -->

                    <br />
                    <fieldset :disabled="!post.editing">
                        <div class="row">
                            <hr class="col" />
                            <h3 class="col">{{langPostEdit.basicInfo[locale]}}</h3>
                            <hr class="col" />
                        </div>
                        <form-input :labelText="langPostEdit.title[locale]" :placeholder="langPostEdit.titlePlaceholder[locale]" v-model="mutablePost.title" :required="true" :tooltipTitle="langPostEdit.titleToolTip[locale]"/>
                        <form-input :labelText="langPostEdit.description[locale]" :placeholder="langPostEdit.descriptionPlaceholder[locale]" v-model="mutablePost.description" :inputType="'textarea'" :tooltipTitle="langPostEdit.descriptionToolTip[locale]"/>
                        <form-input :labelText="langPostEdit.price[locale]" :placeholder="langPostEdit.pricePlaceholder[locale]" v-model="mutablePost.currentPrice" :inputType="'number'" :required="true" :tooltipTitle="langPostEdit.priceToolTip[locale]"/>
                
                        <form-select :labelText="langPostEdit.selectAType[locale]" v-if="filters[locale].Type" v-model="mutablePost.type" :options="filters[locale].Type" :allowedValues="filters[locale].Type.map(item => (item.value))" :required="true" :tooltipTitle="langPostEdit.selectATypeToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectASubType[locale]" v-if="filters[locale].SubType" v-model="mutablePost.subType" :options="filters[locale].SubType" :allowedValues="filters[locale].SubType.map(item => (item.value))" :required="true" :tooltipTitle="langPostEdit.selectASubTypeToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectAMaker[locale]" v-if="filters[locale].Maker" v-model="mutablePost.maker" :options="filters[locale].Maker.concat(['Other'])" :allowedValues="filters[locale].Maker.map(item => (item.value)).concat(['Other'])" :required="true" :tooltipTitle="langPostEdit.selectAMakerToolTip[locale]"/>
                        <form-input :labelText="langPostEdit.otherMakerName[locale]" v-if="mutablePost.maker === 'Other'" :placeholder="langPostEdit.otherMakerNamePlaceholder[locale]" v-model="mutablePost.otherMaker" :required="mutablePost.maker === 'Other'" :tooltipTitle="langPostEdit.otherMakerNameToolTip[locale]"/>
                        <form-filter-condition :labelText="langPostEdit.selectACondition[locale]" v-model="mutablePost.condition" :options="filters[locale].selectCondtionOptions" :allowedValues="filters[locale].selectCondtionOptions.map(item => (item.value))" :required="true" :tooltipTitle="langPostEdit.selectAConditionToolTip[locale]"/>
                        <div style="height: 1rem"/>

                        <br />
                        <div class="row">
                            <hr class="col" />
                            <h3 class="col">{{langPostEdit.locationInfo[locale]}}</h3>
                            <hr class="col" />
                        </div>

                        <form-select :labelText="langPostEdit.selectAProvince[locale]" v-model="mutablePost.province" :options="[{text: langPostEdit.selectAProvince[locale], value: undefined}].concat(PROVINCES.map(item => {return {value: item, text: item}}))" :allowedValues="PROVINCES" :required="true" :tooltipTitle="langPostEdit.selectAProvinceToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectACity[locale]" v-model="mutablePost.city" :disabled="!mutablePost.province" :options="[{text: langPostEdit.selectACity[locale], value: undefined}].concat(CITIES.map(item =>{if(mutablePost.province === item.Maakunta) return {text: item.Kunta, value: item.Kunta};}).filter(item => !!item))" :allowedValues="CITIES.map(item =>{if(mutablePost.province === item.Maakunta) return item.Kunta;}).filter(item => !!item)" :required="true" :tooltipTitle="langPostEdit.selectACityToolTip[locale]"/>
                        
                        <br />
                        <div class="row">
                            <hr class="col" />
                            <h3 class="col">{{langPostEdit.moreInfo[locale]}}</h3>
                            <hr class="col" />
                        </div>

                        <form-select :labelText="langPostEdit.selectAFrameSize[locale]" v-if="filters[locale].FrameSize" v-model="mutablePost.frameSize" :options="filters[locale].FrameSize" :allowedValues="filters[locale].FrameSize.map(item => (item.value))" :tooltipTitle="langPostEdit.selectAFrameSizeToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectAGear[locale]" v-if="filters[locale].Gears" v-model="mutablePost.gears" :options="filters[locale].Gears" :allowedValues="filters[locale].Gears.map(item => (item.value))" :tooltipTitle="langPostEdit.selectAGearToolTip[locale]"/>

                        <form-select :labelText="langPostEdit.selectATyreType[locale]" v-if="filters[locale].TyreType" v-model="mutablePost.tyreType" :options="filters[locale].TyreType" :allowedValues="filters[locale].TyreType.map(item => (item.value))" :tooltipTitle="langPostEdit.selectATyreTypeToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectAMaterial[locale]" v-if="filters[locale].Material" v-model="mutablePost.material" :options="filters[locale].Material" :allowedValues="filters[locale].Material.map(item => (item.value))" :tooltipTitle="langPostEdit.selectAMaterialToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectABreakType[locale]" v-if="filters[locale].BreakType" v-model="mutablePost.breakType" :options="filters[locale].BreakType" :allowedValues="filters[locale].BreakType.map(item => (item.value))" :tooltipTitle="langPostEdit.selectABreakTypeToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectASuspensionType[locale]" v-if="filters[locale].SuspensionType" v-model="mutablePost.suspensionType" :options="filters[locale].SuspensionType" :allowedValues="filters[locale].SuspensionType.map(item => (item.value))" :tooltipTitle="langPostEdit.selectASuspensionTypeToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectAGender[locale]" v-if="filters[locale].Gender" v-model="mutablePost.gender" :options="filters[locale].Gender" :allowedValues="filters[locale].Gender.map(item => (item.value))" :tooltipTitle="langPostEdit.selectAGenderToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectANumOfWheels[locale]" v-if="filters[locale].NumOfWheels" v-model="mutablePost.numOfWheels" :options="filters[locale].NumOfWheels" :allowedValues="filters[locale].NumOfWheels.map(item => (item.value))" :tooltipTitle="langPostEdit.selectANumOfWheelsToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectAWheelSize[locale]" v-if="filters[locale].WheelSize" v-model="mutablePost.wheelSize" :options="filters[locale].WheelSize" :allowedValues="filters[locale].WheelSize.map(item => (item.value))" :tooltipTitle="langPostEdit.selectAWheelSizeToolTip[locale]"/>
                        
                        <form-select :labelText="langPostEdit.selectAMudGuardType[locale]" v-if="filters[locale].MudGuardType" v-model="mutablePost.mudGuardType" :options="filters[locale].MudGuardType" :allowedValues="filters[locale].MudGuardType.map(item => (item.value))" :tooltipTitle="langPostEdit.selectAMudGuardTypeToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectARackType[locale]" v-if="filters[locale].RackType" v-model="mutablePost.rackType" :options="filters[locale].RackType" :allowedValues="filters[locale].RackType.map(item => (item.value))" :tooltipTitle="langPostEdit.selectARackTypeToolTip[locale]"/>
                        <form-select :labelText="langPostEdit.selectABasketType[locale]" v-if="filters[locale].BasketType" v-model="mutablePost.basketType" :options="filters[locale].BasketType" :allowedValues="filters[locale].BasketType.map(item => (item.value))" :tooltipTitle="langPostEdit.selectABasketTypeToolTip[locale]"/>

                        <form-radio-boxes :labelText="langPostEdit.isLockIncluded[locale]" :options="[{value:true, text:langPostEdit.yes[locale]}, {value:false, text:langPostEdit.no[locale]}, {value:undefined, text:langPostEdit.notSure[locale]}]" v-model="mutablePost.lockIncluded" :tooltipTitle="langPostEdit.isLockIncludedToolTip[locale]"/>
                        <form-radio-boxes :labelText="langPostEdit.isFrontLightIncluded[locale]" :options="[{value:true, text:langPostEdit.yes[locale]}, {value:false, text:langPostEdit.no[locale]}, {value:undefined, text:langPostEdit.notSure[locale]}]" v-model="mutablePost.frontLightIncluded" :tooltipTitle="langPostEdit.isFrontLightIncludedToolTip[locale]"/>
                        <form-radio-boxes :labelText="langPostEdit.isRareLightIncluded[locale]" :options="[{value:true, text:langPostEdit.yes[locale]}, {value:false, text:langPostEdit.no[locale]}, {value:undefined, text:langPostEdit.notSure[locale]}]" v-model="mutablePost.rareLightIncluded" :tooltipTitle="langPostEdit.isRareLightIncludedToolTip[locale]"/>
                        <form-radio-boxes :labelText="langPostEdit.legStandExist[locale]" :options="[{value:true, text:langPostEdit.yes[locale]}, {value:false, text:langPostEdit.no[locale]}, {value:undefined, text:langPostEdit.notSure[locale]}]" v-model="mutablePost.legStandExists" :tooltipTitle="langPostEdit.legStandExistToolTip[locale]"/>

                        <b-alert :variant="post.statusOk ? 'success':'danger'" :show="!!post.errMessage || !!post.okMessage">{{post.errMessage || post.okMessage}}</b-alert>

                        <button type="button" class="btn btn-danger" style="margin-right: 0.5em" v-if="post.editing" @click.stop.prevent="postReset">{{langPostEdit.cancel[locale]}}</button>
                        <nettipyora-button v-bind:text="langPostEdit.submit[locale]" v-bind:loading="post.updating" :disabled="getChangedObjKeys.length < 1" v-bind:className="'btn-info'" v-if="post.editing" v-bind:submit="true" />
                    </fieldset>
                    <button type="button" class="btn btn-info" v-if="!post.editing" @click.stop.prevent="$store.commit('POST_EDITING', true)">{{langPostEdit.edit[locale]}}</button>
                </form>
            </div>
            <div v-else>
                <br />
                <b-alert variant="danger" show>{{langPostEdit.notAllowed[locale]}}</b-alert>
            </div>
        </div>
        <br />
    </div>
</template>
<script>
/* eslint-disable no-console */
import { getDiffObjKeys } from '@/store/constant';
import NettipyoraButton from "@/components/NettipyoraButton";
//import FormCheckBoxes from '@/components/FormCheckBoxes';
import FormRadioBoxes from '@/components/FormRadioBoxes';
import FormSelect from '@/components/FormSelect';
import FormInput from '@/components/FormInput';
import FormFilesUploader from '@/components/FormFilesUploader';
import FormFilterCondition from '@/components/FormFilterCondition';
import { mapState } from 'vuex';
import fileUploaderMixin from '@/mixins/fileUploaderMixin';
import { CITIES, PROVINCES } from '@/store/constant';
import langPostEdit from '@/store/lang/postEdit';

export default {
    name: "post-edit",
    mixins: [fileUploaderMixin],
    components: {
        NettipyoraButton,
        //FormCheckBoxes,
        FormRadioBoxes,
        FormSelect,
        FormInput,
        FormFilesUploader,
        FormFilterCondition
    },
    computed: {
        ...mapState({
            locale: state => state.locale,
            filters: state => state.filters,
            post: state => state.PostEdit.post,
            files: state => state.PostEdit.files,
            images: state => state.PostEdit.images,
            videos: state => state.PostEdit.videos
        }),
        getChangedObjKeys() {
            const diff = getDiffObjKeys(this.post.data, this.mutablePost);
            return diff;
        }
    },
    watch: {
        'post.data' (newPost) {
            this.mutablePost = JSON.parse(JSON.stringify(newPost));
        }
    },
    data() {
        return {
            CITIES, PROVINCES, langPostEdit,
            warningModalShow: false,
            confirmModalShow: false,
            warningModalText: "",
            confirmModalText: "",
            mutablePost: {},
            tempData: {
                fileType: "", //image or video
                fileURI: ""
            }
        }
    },
    mounted() {
        this.$store.dispatch('POST_EDIT_FETCH', this.$route.params.postID);
    },
    methods: {
        postReset() {
            this.$store.commit('POST_EDITING', false);
            this.mutablePost = JSON.parse(JSON.stringify(this.post.data));
            console.log(this.mutablePost, JSON.parse(JSON.stringify(this.post.data)));
        },
        updatePost() {
            let payload;
            for(let key in this.mutablePost) {
                if(this.post.data[key] !== this.mutablePost[key] && key !== "imageURIs" && key !== "videoURIs") {
                    if(!payload) payload = {};
                    payload[key] = ["currentPrice", "condition"].indexOf(key) > -1 ? +this.mutablePost[key] : this.mutablePost[key];
                }
            }
            console.log("payload", payload);
            this.$store.dispatch('POST_EDIT_UPDATE', {itemID: this.$route.params.postID, payload: payload});
        },
        imageAdded(files) {
            const self = this;
            self.$store.commit('POST_EDIT_UPLOADING_IMAGE', true);
            self.$refs.imagesModal.show();
            self.singeFileUploader({file: files[0]}).then(uri => {
                self.$store.dispatch('POST_EDIT_UPLOAD_IMAGE', {itemID: self.$route.params.postID, payload: {fileURI: uri, fileType: 'image'}});
            }).catch(err => {
                console.log(err);
                self.$store.commit('POST_EDIT_UPLOADING_IMAGE', true);
                self.$store.commit('POST_EDIT_UPLOADING_IMAGE_ERROR', 'Error. Failed to upload image.');
            });
        },
        deleteImage(index) {
            this.tempData.fileURI = this.files.images[index].uri;
            this.tempData.fileType = "image";
            this.confirmModalText = "Are you sure? This will delete the image from database and will be no longer accessible.";
            this.confirmModalShow = true;
        },
        videoAdded(files) {
            const self = this;
            self.$store.commit('POST_EDIT_UPLOADING_VIDEO', true);
            self.$refs.videosModal.show();
            self.singeFileUploader({file: files[0]}).then(uri => {
                self.$store.dispatch('POST_EDIT_UPLOAD_VIDEO', {itemID: self.$route.params.postID, payload: {fileURI: uri, fileType: 'video'}});
            }).catch(err => {
                console.log(err);
                self.$store.commit('POST_EDIT_UPLOADING_VIDEO', true);
                self.$store.commit('POST_EDIT_UPLOADING_VIDEO_ERROR', 'Error. Failed to upload video.');
            });
        },
        deleteVideo(index) {
            this.tempData.fileURI = this.files.videos[index].uri;
            this.tempData.fileType = "video";
            this.confirmModalText = "Are you sure? This will delete the video from database and will be no longer accessible.";
            this.confirmModalShow = true;
        },
        confirmDelete() {
            if(this.tempData.fileType === "image") {
                this.$refs.imagesModal.show();
                this.$store.dispatch('POST_EDIT_DELETE_IMAGE', {itemID: this.$route.params.postID, params: this.tempData});
            } else if(this.tempData.fileType === "video") {
                this.$refs.videosModal.show();
                this.$store.dispatch('POST_EDIT_DELETE_VIDEO', {itemID: this.$route.params.postID, params: this.tempData});
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.image-preview {
    text-align: left;

    .image {
        position: relative;
        height: 100px;
        width: 150px;
        margin: 5px;
        display: inline-block;
        img {
            height: 100px;
            width: 150px;
            border-radius: 1em;
        }
    }
}
</style>

